import { createEvent, createStore } from 'effector';
import { type PayoutCascadeGroupFilters } from '~/entities/payout';
import { createPagination } from '~/shared/lib/pagination';

export const paginationModel = createPagination();

export const setCascadeGroupsFilter = createEvent<PayoutCascadeGroupFilters>();
export const $cascadeGroupsFilter = createStore<PayoutCascadeGroupFilters>({}).on(
    setCascadeGroupsFilter,
    (state, payload) => ({
        ...state,
        ...payload,
    }),
);
